module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phead11-3110e98b6f36e4df0dc28140b0ace7c3.jpg";